import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { type Carrier, type ChartRow, formatDay } from './carrierDaily'

/** The chart's numbers as a table, one row per day. */
export function CarrierDailyTable({ rows, carriers }: { rows: ChartRow[]; carriers: Carrier[] }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Day</TableHead>
          {carriers.map((carrier) => (
            <TableHead key={carrier.vendor} className="text-right">
              {carrier.name}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.period}>
            <TableCell>{formatDay(row.period, true)}</TableCell>
            {carriers.map((carrier) => (
              <TableCell key={carrier.vendor} className="text-right tabular-nums">
                {row[carrier.vendor]}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
